import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { PrimisVideo } from 'site-modules/shared/components/primins-video/primis-video';
import { getTargeting } from 'site-modules/shared/components/ads-context/ads-context';

const PRIMIS_SRC_MAPPING = {
  gam: {
    afloat: 'https://live.primis.tech/live/liveView.php?s=119495&cbuster=%%CACHEBUSTER%%',
    discovery: 'https://live.primis.tech/live/liveView.php?s=119496&cbuster=%%CACHEBUSTER%%',
  },
  hardcoded: {
    afloat: 'https://live.primis.tech/live/liveView.php?s=119495',
    discovery: 'https://live.primis.tech/live/liveView.php?s=119496',
  },
};

export function PrimisVideoWrapperUI({
  vehicle,
  isMobile,
  pageCategory,
  pageName,
  sessionId,
  visitorId,
  zipCode,
  doNotSell,
  uspString,
  pageParams,
  sect1,
  sect2,
}) {
  const [src, setSrc] = useState('');

  useEffect(() => {
    let queryParams = '';
    const defaultMake = get(pageParams, 'make', '');
    const defaultModel = get(pageParams, 'model', '');
    const defaultSubmodel = get(pageParams, 'submodel', '');
    const defaultYear = get(pageParams, 'year', '');
    const primisProps = {
      ...getTargeting(),
      mk: get(vehicle, 'make.niceName', defaultMake),
      mdl: get(vehicle, 'model.niceName', defaultModel),
      sub: get(vehicle, 'subModel.niceName', defaultSubmodel),
      year: get(vehicle, 'modelYear.year', defaultYear),
      mobile: isMobile,
      edwcat: pageCategory,
      edwpg: pageName,
      edw: sessionId,
      vid: visitorId,
      zip: zipCode,
      doNotSell,
      us_privacy: uspString,
      sect1,
      sect2,
    };
    const keys = Object.keys(primisProps);
    keys.forEach(key => {
      queryParams += `&${key}=${primisProps[key]}`;
    });
    setSrc(PRIMIS_SRC_MAPPING.gam.discovery + queryParams);
  }, [src]);

  return <PrimisVideo src={src} />;
}
PrimisVideoWrapperUI.propTypes = {
  vehicle: VehicleEntities.MakeModelSubmodelYear,
  isMobile: PropTypes.bool,
  pageName: PropTypes.string,
  pageCategory: PropTypes.string,
  zipCode: PropTypes.string,
  visitorId: PropTypes.string,
  sessionId: PropTypes.string,
  doNotSell: PropTypes.bool,
  uspString: PropTypes.string,
  pageParams: PropTypes.shape({}),
  sect1: PropTypes.string,
  sect2: PropTypes.string,
};

PrimisVideoWrapperUI.defaultProps = {
  vehicle: null,
  isMobile: false,
  pageName: null,
  pageCategory: null,
  zipCode: null,
  visitorId: null,
  sessionId: null,
  doNotSell: false,
  uspString: null,
  pageParams: null,
  sect1: null,
  sect2: null,
};

export const mapStateToProps = state => ({
  isMobile: state.mobile,
  pageName: state.pageContext?.page?.name,
  pageCategory: state.pageContext?.page?.category,
  zipCode: state.visitor?.location?.zipCode,
  visitorId: state.visitor?.id,
  sessionId: state.visitor?.session,
  doNotSell: state.visitor?.privacy?.doNotSell,
  uspString: state.visitor?.privacy?.uspString,
  vehicle: state.pageContext?.vehicle,
  sect1: state.pageContext?.page?.adsCustomTargeting?.sect1,
  sect2: state.pageContext?.page?.adsCustomTargeting?.sect2,
});

export const PrimisVideoWrapper = connect(mapStateToProps)(PrimisVideoWrapperUI);
